const initialState = {
    rolesList:{},
    singleRoleDetails:{},
    eligibleDetails:{},
    roleFloatDetails:{},
    cities: [],
    roleCities:[]
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_ROLES_LIST':
        return {
          ...state,
          rolesList: action.data,
        }
        case 'SET_SINGLE_ROLE_DETAILS':
          return {
            ...state,
            singleRoleDetails: action.data,
          }
          case 'SET_ELIGIBLE_DETAILS':
            return {
              ...state,
              eligibleDetails: action.data,
            }
           
            case 'SET_ROLE_FLOAT_DETAILS':
              return {
                ...state,
                roleFloatDetails: action.data,
              }
          case 'SET_CITIES':
            return {
              ...state,
              cities: action.data,
            }
            case 'SET_ROLE_CITIES':
            return {
              ...state,
              roleCities: action.data,
            }
      default:
        return state
    }
  }
  